// Rôles utilisateur
export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  SERVICE: 'service',
  REQUESTER: 'requester',  // Ajout du rôle requester
  TECHNICAL: 'technical',
  // Alias pour assurer la compatibilité avec le code existant
  TECHNICAL_SERVICE: 'technical'
};

// Traductions des rôles
export const USER_ROLE_TRANSLATIONS = {
  [USER_ROLES.SUPER_ADMIN]: 'Super Administrateur',
  [USER_ROLES.ADMIN]: 'Administrateur',
  [USER_ROLES.SERVICE]: 'Service',
  [USER_ROLES.REQUESTER]: 'Service demandeur',  // Traduction pour requester
  [USER_ROLES.TECHNICAL]: 'Service technique',
  [USER_ROLES.TECHNICAL_SERVICE]: 'Service technique'  // Alias pour compatibilité
};

// Types de services
export const SERVICE_TYPES = {
  ADMINISTRATIVE: 'administrative',
  TECHNICAL: 'technical',
  ACADEMIC: 'academic'
};

// Traductions des types de services
export const SERVICE_TYPE_TRANSLATIONS = {
  [SERVICE_TYPES.ADMINISTRATIVE]: 'Administratif',
  [SERVICE_TYPES.TECHNICAL]: 'Technique',
  [SERVICE_TYPES.ACADEMIC]: 'Académique'
};

// Niveaux d'accès
export const ACCESS_LEVELS = {
  FULL: 'full',
  READ: 'read',
  WRITE: 'write',
  NONE: 'none'
};

// Traductions des niveaux d'accès
export const ACCESS_LEVEL_TRANSLATIONS = {
  [ACCESS_LEVELS.FULL]: 'Accès complet',
  [ACCESS_LEVELS.READ]: 'Lecture seule',
  [ACCESS_LEVELS.WRITE]: 'Écriture',
  [ACCESS_LEVELS.NONE]: 'Aucun accès'
};

// Permissions par rôle
export const ROLE_PERMISSIONS = {
  [USER_ROLES.SUPER_ADMIN]: {
    canCreateService: true,
    canEditService: true,
    canDeleteService: true,
    canAssignRoles: true,
    canManageSchools: true,
    canViewAllData: true
  },
  [USER_ROLES.ADMIN]: {
    canCreateService: true,
    canEditService: true,
    canDeleteService: true,
    canAssignRoles: true,
    canManageSchools: false,
    canViewAllData: false
  },
  [USER_ROLES.SERVICE]: {
    canCreateService: false,
    canEditService: false,
    canDeleteService: false,
    canAssignRoles: false,
    canManageSchools: false,
    canViewAllData: false,
    canCreateRequest: true,
    canEditOwnRequest: true,
    canDeleteOwnRequest: true,
    canViewOwnRequests: true,
    canAddComments: true
  },
  [USER_ROLES.REQUESTER]: {  // Permissions pour le rôle requester
    canCreateService: false,
    canEditService: false,
    canDeleteService: false,
    canAssignRoles: false,
    canManageSchools: false,
    canViewAllData: false,
    canCreateRequests: true,
    canViewOwnRequests: true
  },
  [USER_ROLES.TECHNICAL]: {
    canCreateService: false,
    canEditService: false,
    canDeleteService: false,
    canAssignRoles: false,
    canManageSchools: false,
    canViewAllData: false,
    canViewAssignedRequests: true,
    canUpdateRequestStatus: true,
    canAddComments: true,
    canAssignTasks: true
  }
};
